<div class="main_content">
    <div class="page_main_sec">
        <div class="col-12">
            <div class="row">
                <div class="col-lg-4 col-md-3"></div>
                <div class="col-lg-4 col-md-6">
                    <div class="hw-70vh">
                      <div class="session_card_image_box">
                        <div class="session_img_box session-error-cognix">
                          <img src="../../../assets/img/error/App_tni_ani_001.png"
                               class="session_monitor" alt="eroor" /> <img src="../../../assets/img/error/circle3_tni_ani_001.png" alt="eroor" class="session_circle1" />
                          <img src="../../../assets/img/error/circle3_tni_ani_001.png" alt="eroor" class="session_circle2" />
                          <img src="../../../assets/img/error/circle3_tni_ani_001.png" alt="eroor" class="session_circle3" />
                          <img src="../../../assets/img/error/plus2_tni_ani_001.png" alt="eroor" class="session_plus1" /> <img src="../../../assets/img/error/plus3_tni_ani_001.png" alt="eroor" class="session_plus2" />
                        </div>
                        <div class="session_img_box session-error-tml">
                          <img src="../../../assets/img/error/App_tni_ani_001-tml.png"
                               class="session_monitor" alt="eroor" /> <img src="../../../assets/img/error/circle3_tni_ani_001-tml.png" alt="eroor" class="session_circle1" />
                          <img src="../../../assets/img/error/circle3_tni_ani_001-tml.png" alt="eroor" class="session_circle2" />
                          <img src="../../../assets/img/error/circle3_tni_ani_001-tml.png" alt="eroor" class="session_circle3" />
                          <img src="../../../assets/img/error/plus2_tni_ani_001-tml.png" alt="eroor" class="session_plus1" /> <img src="../../../assets/img/error/plus3_tni_ani_001-tml.png" alt="eroor" class="session_plus2" />
                        </div>
                        <img src="../../../assets/img/error/base_tni_ani_001.png" alt="eroor"
                             class="session_base" />
                      </div>
                        <div class="card-body">
                            <h2 class="card_heading">
                                <p [innerHTML]="PrimaryMessage">
                                </p>
                            </h2>

                            <p *ngIf="SecondaryMessage!=''" class="card_text" [innerHTML]="SecondaryMessage"></p>

                            <p class="card_text">You will be redirected to the Login Page.</p>
                            <!-- <div class="text-center">
                                <button type="button" class="card_button" (click)="redirectToPage('login')">OK</button>
                            </div> -->
                            <div class="text-center" *ngIf="unauthorized">
                                <button type="button" class="card_button" (click)="redirectToPage('login')">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4"></div>
            </div>
        </div>
    </div>
</div>
